import { SalaryStructureStatus } from 'components/SalaryStructure/types';
import { WarningModalType } from './types';

// Using string type instead of FilterType as it's not exported
type FilterConfig = {
  key: string;
  defaultValue?: string;
};

export const tabItems = {
  active: 'active',
  inactive: 'inactive',
};

export const salaryStructureQueries = {
  getSalaryStructuresList: 'getSalaryStructuresList',
  getSalaryStructure: 'getSalaryStructure',
  createSalaryStructure: 'createSalaryStructure',
  updateSalaryStructure: 'updateSalaryStructure',
  getSalaryComponentSDIs: 'getSalaryComponentSDIs',
  setSalaryStructureStatus: 'setSalaryStructureStatus',
  getSalaryStructuresForUsers: 'getSalaryStructuresForUsers',
  getEmployeesBySalaryStructure: 'getEmployeesBySalaryStructure',
  getUsersByPeopleIds: 'getUsersByPeopleIds',
};

export const salaryStructureParams = {
  structureId: 'structureId',
};

export const salaryStructureFiltersMap: Record<string, FilterConfig> = {
  status: {
    key: 'status',
    defaultValue: 'active',
  },
};

export const helpArticles = {
  learnMore: 'https://razorpay.com/learn/payroll-salary-structure',
};

export const statusFilters = {
  all: 'All structures',
  active: 'Active',
  inactive: 'Disabled',
};

export const statusFiltersMap: Record<string, SalaryStructureStatus> = {
  all: 'SALARY_STRUCTURE_STATUS_NONE',
  active: 'SALARY_STRUCTURE_STATUS_ACTIVE',
  inactive: 'SALARY_STRUCTURE_STATUS_INACTIVE',
};

export const warningModalTypes: WarningModalType = {
  PROCEED_TO_EDIT: 'PROCEED_TO_EDIT',
};
